import React, {useState} from 'react';
import {Popover, PopoverBody} from "reactstrap";
import DropdownItem from "../../clipstore/broadcaster/library/dropdown-item/DropdownItem";
import assets from "../../../util/assets";
import "./index.css";
import api from "../../../util/messaging/api";
import messaging_utility from "../../../util/messaging/utility";
import {getEncryptedIdForBroadcaster} from "../../../util/broadcast_util";
import strings from "../../../util/strings";
import * as _ from "lodash";
import sb from "../../../util/sendbird";

ChatWindowDetailDropdown.propTypes = {};

const getUserType = (member) => {
    return member.metaData.is_user === "True" ? "user" : "broadcaster"
}

function ChatWindowDetailDropdown(props) {

    let member = messaging_utility.retrieveMemberDetails(props, props.selectedChannel);
    if (member.length === 1) {
        member = member[0]
    }
    const user_type = getUserType(member);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const toggle = () => setPopoverOpen(!popoverOpen);

    const dropDownItem = [{
        slug: 'view-profile',
        title: "View Profile",
        icon: assets.messaging.dropdown.view_profile,
        action: () => {
            console.log("View Profile")
            if(user_type !== "user"){
                props.history.push('/profile/' + getEncryptedIdForBroadcaster(member.userId))
            }else{
                props.history.push('/user/profile/' + getEncryptedIdForBroadcaster(member.userId))
            }
        }
    },{
        slug: 'archive-chat',
        title: "Archive Chat",
        icon: assets.messaging.dropdown.archive,
        action: () => {
            const payload = {
                image: assets.messaging.dropdown.archive,
                title: strings.messaging.archive_message.title,
                description: strings.messaging.archive_message.description
            };
            const isConfirmationModal = true;
            const actionArray = [{
                text: "CANCEL",
                click: () => {
                    console.log("Clicked on CANCEL");
                    props.hideCommonModal()
                }
            }, {
                text: "ARCHIVE",
                click: () => {
                    console.log("Clicked on OK")
                    props.archive();
                }
            }];

            props.showCommonModal(payload, isConfirmationModal, actionArray);
        }
    },{
        slug: 'block',
        title: "Block",
        icon: assets.messaging.dropdown.block,
        action: () => {
            console.log("Block")
            const payload = {
                image: assets.messaging.dropdown.block,
                title: strings.messaging.block_message.title,
                description: strings.messaging.block_message.description
            };
            const isConfirmationModal = true;
            const actionArray = [{
                text: "CANCEL",
                click: () => {
                    console.log("Clicked on CANCEL");
                    props.hideCommonModal()
                }
            }, {
                text: "BLOCK",
                click: () => {
                    console.log("Clicked on OK")
                    api.blockUser(props,member.userId,user_type === "user" ? "broadcaster" : "user")
                }
            }];

            props.showCommonModal(payload, isConfirmationModal, actionArray);
        }
    }];

    // const dropDownItem = [{
    //     slug: 'view-profile',
    //     title: "View Profile",
    //     icon: assets.messaging.dropdown.view_profile,
    //     action: () => {
    //         console.log("View Profile")
    //         props.history.push('/profile/' + getEncryptedIdForBroadcaster(member.userId))
    //     }
    // }, {
    //     slug: 'select-messages',
    //     title: "Select Messages",
    //     icon: assets.messaging.dropdown.select_messages,
    //     action: () => {
    //         console.log("Select Messages")
    //     }
    // }, {
    //     slug: 'archive-chat',
    //     title: "Archive Chat",
    //     icon: assets.messaging.dropdown.archive,
    //     action: () => {
    //        props.archive();
    //     }
    // }, {
    //     slug: 'mute-notifications',
    //     title: "Mute Notifications",
    //     icon: assets.messaging.dropdown.mute,
    //     action: () => {
    //         console.log("Mute Notifications")
    //     }
    // }, {
    //     slug: 'block',
    //     title: "Block",
    //     icon: assets.messaging.dropdown.block,
    //     action: () => {
    //         console.log("Block")
    //         api.blockUser(props,member.userId,user_type === "user" ? "broadcaster" : "user")
    //     }
    // }, {
    //     slug: 'report',
    //     title: "Report",
    //     icon: assets.messaging.dropdown.report,
    //     action: () => {
    //         console.log("Report")
    //     }
    // }];

    return (
        <div>
            <img
                className="cursor-pointer padding-16"
                src={popoverOpen ? assets.messaging.dropdown.icon.active : assets.messaging.dropdown.icon.inactive} id={`direct-messaging-header-more`}/>

            <Popover placement="bottom" isOpen={popoverOpen} target={`direct-messaging-header-more`} toggle={toggle} className="chat-window-detail-header-popover">
                <PopoverBody className="my-library-actions-pop-over-body">
                    <div>
                        {
                            dropDownItem.map((item, index) => {

                                return (
                                    <DropdownItem
                                        isFetching={props.isFetching && selectedItem === item}
                                        key={`chat-window-dropdown-item-${index}`}
                                        onClick={() => {
                                            toggle();
                                            setSelectedItem(item)
                                            item.action();
                                        }}
                                        icon={item.icon}
                                        text={item.title}
                                    />
                                )

                            })
                        }
                    </div>
                </PopoverBody>
            </Popover>
        </div>
    );
}

export default ChatWindowDetailDropdown;